module.exports = __webpack_public_path__ + "img/77354.8ed3e90b.svg";